import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/combos';

class ComboService {
  static async getAllCombos(params = {}) {
    const clientCode = sessionStorage.getItem('clientCode');

    const requestParams = {
      clientCode,
      search: params.search || '',
      page: params.currentPage ?? params.page ?? 0,
      size: params.pageSize ?? params.size ?? 10,
      sort: params.sort || ''
    };

    if (params.active !== undefined && params.active !== null) {
      requestParams.active = params.active;
    }

    if (params.minPrice !== undefined) requestParams.minPrice = params.minPrice;
    if (params.maxPrice !== undefined) requestParams.maxPrice = params.maxPrice;

    if (params.categories && Array.isArray(params.categories)) {
      requestParams.categories = params.categories;
    }

    const response = await api.get(
      `${BASE_PATH}/listarCombos`,
      { params: requestParams }
    );
    return response.data;
  }

  static async findSpecificCombo(comboId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarCombo`,
      { params: { clientCode, searchInput: comboId } }
    );
    return response.data;
  }

  static async registerCombo(combo) {
    const response = await api.post(
      `${BASE_PATH}/adicionarCombo`,
      combo
    );
    return response.data;
  }

  static async updateCombo(comboId, combo) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCombo`,
      combo,
      { params: { comboId } }
    );
    return response.data;
  }

  static async updateComboQuantity(searchInput, action, combo) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.put(
      `${BASE_PATH}/atualizarQuantidadeCombo`,
      combo,
      { params: { clientCode, searchInput, action } }
    );
    return response.data;
  }

  static async deleteCombo(comboId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerCombo`,
      { params: { clientCode, comboId } }
    );
    return response.data;
  }
}

export default ComboService;